import { render, staticRenderFns } from "./EditPersonalInfo.vue?vue&type=template&id=a305ed88"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./EditPersonalInfo.vue?vue&type=style&index=0&id=a305ed88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports